import { useState } from 'react'
import type { StripeElements } from '@stripe/stripe-js'

/*
  The express Elements group is recreated (remounted via key) whenever the intent mode flips,
  but the component state still holds the previous instance until the new mount registers itself.
  In that window elements.update() with payment-mode options (amount) against a setup-mode
  instance throws an IntegrationError. Each registered instance is stamped with the mode it was
  created for, and `elementsMatchesMode` is false until the instance for the current mode arrives.
*/
export const useExpressStripeElements = (withSetupIntent: boolean) => {
  const [elementsState, setElementsState] = useState<{ elements: StripeElements; forSetupIntent: boolean }>({
    elements: null,
    forSetupIntent: withSetupIntent,
  })

  const setStripeElements = (elements: StripeElements) =>
    setElementsState({ elements, forSetupIntent: withSetupIntent })

  return {
    elements: elementsState.elements,
    elementsMatchesMode: elementsState.forSetupIntent === withSetupIntent,
    setStripeElements,
  }
}
